import { InjectionToken } from '@angular/core';
import { CommonsNewHttpUtilsErrorService } from 'ib-web-commons/app/core/utils/http-utils-services/ib-commons-new-http-utils-error-service';
import { upgradeAJSServiceProvider } from 'ib-web-commons/utils'; 
export const AJSGiftCardsCommonsNewHttpUtilsErrorService = new InjectionToken('CommonsNewHttpUtilsErrorService');
export const AJSGiftCardsCommonsNewHttpUtilsErrorServiceProvider = upgradeAJSServiceProvider('CommonsNewHttpUtilsErrorService', AJSGiftCardsCommonsNewHttpUtilsErrorService);
export interface GiftCardsCommonsNewHttpUtilsErrorServiceType extends CommonsNewHttpUtilsErrorService {
    controlError(error, reject),
}
